import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { PRODUCT_MARK, PRODUCT_NAME, PRODUCT_TAGLINE_EN, PRODUCT_TAGLINE_ZH } from '../config/brand';

const AboutPage = () => {
    const { language } = useLanguage();
    const isZh = language === 'zh';

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 'calc(100vh - 56px - 3rem)',
        }}>
            <div style={{
                maxWidth: '560px',
                width: '100%',
                textAlign: 'center',
            }}>
                {/* Logo / Brand */}
                <div style={{
                    width: '72px',
                    height: '72px',
                    borderRadius: '20px',
                    background: 'linear-gradient(135deg, #007AFF 0%, #5856D6 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 28px',
                    boxShadow: '0 8px 24px rgba(0, 122, 255, 0.25)',
                }}>
                    <span style={{
                        fontSize: '1.8rem',
                        fontWeight: '800',
                        color: '#fff',
                        letterSpacing: '-0.04em',
                    }}>{PRODUCT_MARK}</span>
                </div>

                {/* Title */}
                <h1 style={{
                    fontSize: '2rem',
                    fontWeight: '700',
                    letterSpacing: '-0.03em',
                    color: '#1D1D1F',
                    margin: '0 0 12px',
                }}>
                    {PRODUCT_NAME}
                </h1>

                {/* Tagline */}
                <p style={{
                    fontSize: '1rem',
                    color: '#86868B',
                    fontWeight: '500',
                    letterSpacing: '0.12em',
                    margin: '0 0 40px',
                }}>
                    {isZh ? PRODUCT_TAGLINE_ZH : PRODUCT_TAGLINE_EN}
                </p>

                {/* Card */}
                <div style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.72)',
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    borderRadius: '16px',
                    padding: '36px 40px',
                    border: '1px solid rgba(0, 0, 0, 0.06)',
                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.04)',
                }}>
                    <p style={{
                        fontSize: '1.05rem',
                        lineHeight: '1.9',
                        color: '#1D1D1F',
                        margin: 0,
                    }}>
                        {isZh
                            ? '区块链与人工智能，专注于技术创新和深度思考，发现并创造长期价值。'
                            : 'Blockchain and AI — focused on technological innovation and deep thinking, discovering and creating long-term value.'}
                    </p>
                </div>

                {/* Contact */}
                <div style={{ marginTop: '36px' }}>
                    <a
                        href="mailto:everclooney@gmail.com"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontSize: '0.92rem',
                            color: '#86868B',
                            textDecoration: 'none',
                            padding: '8px 20px',
                            borderRadius: '10px',
                            border: '1px solid rgba(0, 0, 0, 0.08)',
                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={e => {
                            e.currentTarget.style.color = '#007AFF';
                            e.currentTarget.style.borderColor = 'rgba(0, 122, 255, 0.3)';
                            e.currentTarget.style.backgroundColor = 'rgba(0, 122, 255, 0.06)';
                        }}
                        onMouseLeave={e => {
                            e.currentTarget.style.color = '#86868B';
                            e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.08)';
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
                        }}
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="2" y="4" width="20" height="16" rx="2" />
                            <path d="M22 4L12 13L2 4" />
                        </svg>
                        商业合作联系 everclooney@gmail.com
                    </a>
                </div>
            </div>
        </div>
    );
};

export default AboutPage;
